import React, { useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { defaultUser } from '../../../../constants/user';
import { emailExists } from '../../../../apis/register';
import { UserType } from '../../../../types/User';
import RegisterLayout from '../../../../components/layout/RegisterLayout';
import RegisterInCategoryFirstStep from './RegisterInCategoryFirstStep';
import RegisterInCategorySecondStep from './RegisterInCategorySecondStep';

interface MatchParams {
  asu: string;
}

const RegisterInCategoryTwoSteps: React.FC<RouteComponentProps<
  MatchParams
>> = ({ match }) => {
  const [user, setUser] = useState<UserType>(defaultUser);
  const [step, setStep] = useState<1 | 2>(1); // two steps registration
  const [loading, setLoading] = useState(false);

  const { asu } = match.params;

  const handleSubmit = async (email: string) => {
    setLoading(true);
    try {
      const data: UserType | '' = await emailExists(email);

      if (data === '') {
        // New user
        setUser({ ...user, email: email });
      } else {
        // Existing user
        setUser(data);
      }
      setStep(2);
    } catch (error) {
      // handle error;
    } finally {
      setLoading(true);
    }
  };

  return (
    <RegisterLayout
      title={step === 1 ? 'Email Verification' : 'Account Creation'}
    >
      {step === 1 && (
        <RegisterInCategoryFirstStep
          onSubmit={handleSubmit}
          loading={loading}
        />
      )}
      {step === 2 && (
        <RegisterInCategorySecondStep user={user} category={asu} />
      )}
    </RegisterLayout>
  );
};

export default withRouter(RegisterInCategoryTwoSteps);
